import axios from 'axios';

const clienteAxios = axios.create({
    baseURL : 'https://app.facturandoenlinea.mx'
});

export default clienteAxios;